<!--
~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
~ This software is the proprietary information of Irian Software Development SRL.
~ Use is subject to license and non-disclosure terms
-->

@if (displayButton) {
  <div style="display: flex">
    <button bsButton type="button" class="flat notification-ui-button-component"
      (click)="handleClick()" data-testid="click-btn"><span class="ui-icon-notifications" bsButtonIcon></span><span bsButtonLabel>{{ count | async }}</span></button>
    </div>
  }
